import { IBgVariantItem } from '../types';

export const LETTER_SPACE_MULTIPLIER = 5;
export const INCLINE_MULTIPLIER = 50;
export const MIN_TRANFORMER_SIZE = 10;

export const bgVariantsList: IBgVariantItem[] = [
  {
    title: 'Bg 1',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2020/11/Z-125.01.jpg',
    active: true,
  },
  {
    title: 'Bg 2',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2021/02/Z-127.jpg',
    active: false,
  },
  {
    title: 'Bg 3',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2021/01/BM-118.jpg',
    active: false,
  },
  {
    title: 'Bg 4',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2020/11/Z-125.01.jpg',
    active: false,
  },
  {
    title: 'Bg 5',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2021/02/Z-127.jpg',
    active: false,
  },
  {
    title: 'Bg 6',
    img: 'https://ihopetoseeyou.com/wp-content/uploads/2021/01/BM-118.jpg',
    active: false,
  },
];

export const SMS_CONSENT_COOKIE = 'sms_consent';
export const COOKIE_EXPIRATION_DAYS_SMS_CONSENT = 30;
